import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MovieIcon(props: IconProps) {
    return <Icon {...props} iconKey={"movie"}/>
}
